<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{$t(page+'.'+message)}}</span>
    </v-snackbar>
    <v-card class="neu-glow elevation-8 pb-3 mb-3 ml-3">
      <v-card-title primary-title class="pb-0">
        <div class="text-h5">Sfondi/Immagini</div>
        <v-spacer></v-spacer>
        <v-div>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon  fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                <v-icon color="info">mdi-sync-circle</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>           
        </v-div>
      </v-card-title>
      <v-container grid-list-xl fluid>
        <v-row class="my-2">
          <v-col md="6" cols="12">
              <div class="ml-2">
                Immagine 1 (1920 x 1080px)              
              </div>
          </v-col>
          <v-col md="6" cols="12" class="py-0">
            <div class="d-flex flex-column justify-space-between align-center">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div class="elevation-10" v-bind="attrs" v-on="on" id="pick-avatar10" style="cursor:pointer">
                    <v-img
                      :lazy-src="picture_0"
                      max-height="384"
                      max-width="216"
                      :src="picture_0"
                    ></v-img>
                  </div>                  
                </template>
                <span>Cambia</span>
              </v-tooltip>                
            </div>
            <avatar-cropper
              :uploadFormData="{name:'picture_0',type:'picture'}"
              :outputOptions="outputOptions0"
              :cropperOptions="cropperOptions0"
              @uploading="handleUploading"
              @uploaded="handleUploaded"
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar10"
              upload-url="https://booking.jslab.it/ajax/settings/upload.php" 
            />
          </v-col>
        </v-row>
        <v-row class="my-2">
          <v-col md="6" cols="12">
            <div class="ml-2">
              Immagine 2 (1920 x 1080px)                
            </div>
          </v-col>
          <v-col md="6" cols="12" class="py-0">
            <div class="d-flex flex-column justify-space-between align-center">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div class="elevation-10" v-bind="attrs" v-on="on" id="pick-avatar11" style="cursor:pointer">
                    <v-img
                      :lazy-src="picture_1"
                      max-height="384"
                      max-width="216"
                      :src="picture_1"
                    ></v-img>
                  </div>                  
                </template>
                <span>Cambia</span>
              </v-tooltip>                 
            </div>
            <avatar-cropper
              :uploadFormData="{name:'picture_1',type:'picture'}"
              :outputOptions="outputOptions0"
              :cropperOptions="cropperOptions0"
              @uploading="handleUploading"
              @uploaded="handleUploaded"
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar11"
              upload-url="https://ibookrestaurant.com/ajax/settings/upload.php" 
            />
          </v-col>
        </v-row>
        <v-row class="my-2">
          <v-col md="6" cols="12">
            <div class="ml-2">
              Immagine 3 (1920 x 1080px)   
            </div>
          </v-col>
          <v-col md="6" cols="12" class="py-0">
            <div class="d-flex flex-column justify-space-between align-center">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div class="elevation-10" v-bind="attrs" v-on="on" id="pick-avatar12" style="cursor:pointer">
                    <v-img
                      :lazy-src="picture_2"
                      max-height="384"
                      max-width="216"
                      :src="picture_2"
                    ></v-img>
                  </div>                  
                </template>
                <span>Cambia</span>
              </v-tooltip>               
            </div>
            <avatar-cropper
              :uploadFormData="{name:'picture_2',type:'picture'}"
              :outputOptions="outputOptions0"
              :cropperOptions="cropperOptions0"
              @uploading="handleUploading"
              @uploaded="handleUploaded"
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar12"
              upload-url="https://ibookrestaurant.com/ajax/settings/upload.php" 
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5">
                <v-col md="6" cols="12">
                    <p>
                        Ai fini di semplificare la gestione dell'attività è possibile suddividere l'attività sia in funzione dello spazio che del tempo per adattarla alle proprie necessità:
                    </p>
                    <p>
                      A livello spaziale, distinguiamo tra suddivisioni esplicite (Aree), che il cliente potrà selezionare, e suddivisioni implicite (Sale), che gestirà l'operatore:<br /><br />
                      come suddivisioni esplicite, "interno" ed "esterno" sono solitamente sufficienti, ma qualora vi sia una o più aree particolari è possibile aggiungerle.<br />
                      le suddivisioni implicite invece saranno le sale o porzioni di esse come da voi definite nel riquadro in basso:<br>es: "Sala1", "Sala2", etc. oppure "Sala Interna", "Sala Esterna"
                      una volta create le sale queste andranno "collegate" all'Area di competenza.
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Per ogni Area è possibile definire giorno e mese sia di inizo che di fine Operatività: è importante definire questi parametri in quanto l'area sarà prenotabile da parte del cliente solo nel periodo in cui è operativa.
                    </p>                  
                    <p>
                      Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                    </p>
                    <p>
                      Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                    </p>
                </v-col>
                <v-col cols="12">
                    <p color="error">
                        <strong>Attenzione:</strong> Questi vingoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>     
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import AvatarCropper from "../AvatarCropper";
import _ from 'lodash'
export default {
components: { AvatarCropper },
  data() {
    return {
      page: "Account",
      snackbar: false,     
      message:'',
      dialog_instruction:false,
      pictures:null,
      picture_0:'/static/logos/empty_1920_1080.png',
      picture_1:'/static/logos/empty_1920_1080.png',
      picture_2:'/static/logos/empty_1920_1080.png',
      snackbar_color:'success', 
      outputOptions0:{
        width: 16,
        height: 16,
        minWidth: 16,
        minHeight: 16,
        maxWidth: 16,
        maxHeight: 16,
        fillColor: '#fff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      },
      cropperOptions0:{aspectRatio: 1,    dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: false},
    };
  },
  computed: {
      ...mapGetters(["settings"]),
  },
  created(){
    this.getData()
  },
  methods: {
    save: _.debounce(function (event) {
        this.updateDB(event.target.name,event.target.value)
    }, 1000),
    handleUploading({ form, request }) {
      // show a loader
      console.log(174, {form, request})
    },
    handleCompleted({ response,form1 } )
    {
      console.log(184, response)
      console.log(185, form1)
      this[form1.name]=response.payload;
      this.snackbar=true;
      this.snackbar_color='success';
      this.message='Logo saved';
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(190, form, request, response)
      }
    },
    save2(value, field) {
      //console.log(value, field);
      this.updateDB(field, value)
    },
    async getData(origin)
    {
      try{
          const payload=JSON.stringify({"date": this.date,"action":"AllPictures_get"});
          const res = await this.$http.post('/settings/settings.php', payload );
          console.log(275,res);
          this.loading_refresh=false;
          switch (res.data.errorid)
          {
          case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.pictures=res.data.payloads.allPictures;
              this.pictures.forEach(l => {
                                        //console.log(266,l,l.name,l.URL)
                                        //console.log(267,this[l.name])
                                        this[l.name]='/static/pictures/'+l.URL
                                        //console.log(269,this[l.name])
                                      }
                                );
              console.log(315,this.pictures)
          break;
          case '0006':
              this.$router.push('/auth/login').catch(() => {});
          break;
          }
          this.loading= false;
      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      } 
    },    
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>